var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.37 19.796c-1.042 1.01-2.179.85-3.273.372-1.158-.489-2.22-.51-3.442 0-1.53.659-2.338.467-3.252-.372C2.22 14.452 2.983 6.313 8.87 6.016c1.434.074 2.433.786 3.272.85 1.254-.255 2.454-.988 3.793-.893 1.604.128 2.816.765 3.612 1.913-3.314 1.987-2.528 6.353.51 7.575-.605 1.594-1.391 3.177-2.698 4.346l.01-.01ZM12.035 5.952c-.16-2.37 1.764-4.324 3.973-4.515.309 2.74-2.486 4.78-3.973 4.515Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleFill);
export default __webpack_public_path__ + "static/media/apple_fill.8903bcb06b990a427fd1e3b33f725913.svg";
export { ForwardRef as ReactComponent };